import { NavigationEnd, Router } from '@angular/router';
import { Component, Input } from '@angular/core';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() footerLinks: any;
  @Input() socialLinks: any;

  public idDefensePage = false;

  private unsubscribe$ = new Subject();

  constructor(
    private router: Router,
  ) {
    this.router.events
      .pipe(
        takeUntil(this.unsubscribe$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => this.idDefensePage = event.url.includes('defense'));
  }
}
